import { render, staticRenderFns } from "./TickCross.vue?vue&type=template&id=723f1d2c&"
import script from "./TickCross.vue?vue&type=script&lang=js&"
export * from "./TickCross.vue?vue&type=script&lang=js&"
import style0 from "./TickCross.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports